import { environment } from '../../../../environments/environment';
import * as CryptoJS from 'crypto-js';

export const encrypt = (data: string): string => {
  try {
    // Genera un salt aleatorio de 16 bytes (128 bits)
    const salt = CryptoJS.lib.WordArray.random(16);
    // Deriva una clave a partir de la clave maestra y el salt
    const key = CryptoJS.PBKDF2(environment.keyEcrypt, salt, {
      keySize: 256 / 32, // Tamaño de clave de 256 bits
      iterations: 1000,   // Número de iteraciones para derivar la clave (ajusta según tus necesidades)
    });
    // Cifra el dato utilizando la clave derivada y un IV aleatorio
    const iv = CryptoJS.lib.WordArray.random(16);
    const ciphertext = CryptoJS.AES.encrypt(data, key, { iv }).toString();
    // Concatena el salt y el IV al cifrado antes de retornarlo
    return salt.toString() + iv.toString() + ciphertext;
  } catch (e) {
    return null;
  }
};

export const decrypt = <T>(valueEncrypt: string): T | null => {
  // Extrae el salt de los primeros 16 bytes
  const salt = CryptoJS.enc.Hex.parse(valueEncrypt.slice(0, 32));
  // Extrae el IV siguiente
  const iv = CryptoJS.enc.Hex.parse(valueEncrypt.slice(32, 64));
  // El resto del dato es el cifrado
  const ciphertext = valueEncrypt.slice(64);
  // Deriva una clave a partir de la clave maestra y el salt
  const key = CryptoJS.PBKDF2(environment.keyEcrypt, salt, {
    keySize: 256 / 32,
    iterations: 1000,
  });
  // Descifra el dato utilizando la clave derivada y el IV
  const decrypted = CryptoJS.AES.decrypt(ciphertext, key, { iv });

  if (!decrypted) {
    return null;
  }

  // Convierte el dato descifrado a texto y luego a objeto (asumiendo JSON)
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)) as T;
};